import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { getSectorList } from '../../../helpers/establishment/backend_helper';
import { getBeachCleaningReasonList } from '../../../helpers/residue/backend_helper';
import ResumeBeachCleaning from '../ResumeBeachCleaning';
import BeachCleaningReporte from '../Reports/BeachCleaningReport';
import { pdf } from '@react-pdf/renderer';
import { Icons } from '../../../utils/Icons';
import { toast } from 'react-toastify';

const ResumeTab = ({
    info,
    participants,
    residuesCollected,
    photographicRecords,
    validation
}) => {

    const handleFinalSubmit = () => {
        const hasResponsible = participants.some(p => p.responsible === true);
        if (!hasResponsible) {
            toast.error('Debe haber al menos un responsable en la lista de participantes.');
            return;
        }
        const hasFotoInicial = photographicRecords.some(r => r.record_type?.name === 'Foto Inicial');
        if (!hasFotoInicial) {
            toast.error('Debe adjuntar al menos una fotografía inicial.');
            return;
        }
        const hasFotoFinal = photographicRecords.some(r => r.record_type?.name === 'Foto Final');
        if (!hasFotoFinal) {
            toast.error('Debe adjuntar al menos una fotografía final.');
            return;
        }
        validation.handleSubmit();
    };

    return (
        <React.Fragment>
            <div className='hstack gap-2 justify-content-end mb-3'>
                 {/* <button
                    type='button'
                    className='btn btn-label btn-secondary'
                    onClick={() => {
                        printResume();
                    }}
                >
                    <i className={`${Icons.check} label-icon`}></i>
                    Finalizar Registro
                </button> */}
                <button
                    type='button'
                    className='btn btn-label btn-primary'
                    onClick={handleFinalSubmit}
                >
                    <i className={`${Icons.check} label-icon`}></i>
                    Finalizar Registro
                </button>
            </div>
            <div>
                <ResumeBeachCleaning
                    info={info}
                    participants={participants}
                    residuesCollected={residuesCollected}
                    photographicRecords={photographicRecords}
                />
            </div>
        </React.Fragment>
    )
}

export default ResumeTab;